import type { FC } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import styled from "styled-components";
import Icon from "@components/Icon";
import { helpsiteTrackLink } from "@helpers/helpsite-mixpanel";

const colours = { MIDNIGHT_BLUE: "#121252" };

/* Same as ContactSupportInfo: #F3F3F3, 1px dashed border */
const Container = styled.div`
	width: 100%;
	box-sizing: border-box;
	margin: 24px 0;
	padding: 10px;
	background-color: #f3f3f3;
	border: 1px dashed #000000;
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 10px;
`;

const IconWrapper = styled.div`
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
`;

const TextBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	flex: 1;
	min-width: 0;
`;

const Title = styled.span`
	font-family: var(--euclid-regular);
	font-size: 15px;
	font-weight: 700;
	line-height: 1.5;
	color: ${colours.MIDNIGHT_BLUE};
`;

const Subtext = styled.p`
	font-family: var(--euclid-regular);
	font-size: 14px;
	font-weight: 400;
	line-height: 1.5;
	color: ${colours.MIDNIGHT_BLUE};
	margin: 0;
	opacity: 0.9;
`;

const GetMoreInfoLink = styled(Link)`
	color: inherit !important;
	text-decoration: underline !important;
	font-weight: 400 !important;
	font-size: inherit !important;
	background: none !important;
	border: none !important;
	box-shadow: none !important;
	outline: none !important;
	transition: none !important;

	&:hover,
	&:active,
	&:focus {
		opacity: 1 !important;
		background: none !important;
		border: none !important;
		box-shadow: none !important;
		transform: none !important;
		transition: none !important;
	}
`;

const SimScanningTroubleInfo: FC = () => {
	const router = useRouter();
	const pagePath = router.asPath.split("?")[0];

	return (
		<Container>
			<IconWrapper>
				<Icon
					iconName="sim-scan-trouble"
					iconSizes={{
						iconMobile: 40,
						iconTablet: 40,
						iconLaptop: 40,
						iconDesktop: 40,
						iconDesktopLarge: 40,
					}}
					alt=""
				/>
			</IconWrapper>
			<TextBlock>
				<Title>Having trouble scanning your SIM?</Title>
				<Subtext>
					<GetMoreInfoLink
						href="#"
						onClick={() =>
							helpsiteTrackLink({
								helpsite_section: "sim_scanning_trouble",
								page_path: pagePath,
								link_href: "#",
								label: "Get more info",
							})
						}
					>
						Get more info
					</GetMoreInfoLink>{" "}
					on how to fix this.
				</Subtext>
			</TextBlock>
		</Container>
	);
};

export default SimScanningTroubleInfo;
